import { render } from "./LoadingUserData.vue?vue&type=template&id=524c024d"
import script from "./LoadingUserData.vue?vue&type=script&lang=js"
export * from "./LoadingUserData.vue?vue&type=script&lang=js"

import "./LoadingUserData.vue?vue&type=style&index=0&id=524c024d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__